module.exports = __webpack_public_path__ + "img/BRI-logo.1bbd64fc.svg";